import React, { useEffect, useState } from 'react'
import { FaPlus, FaEdit } from 'react-icons/fa'
import Empty from '../feedback/Empty'
import Loading from '../feedback/Loading'
import moment from 'moment'
import adminServices from '../../services/AdminServices'
import CategoryModal from '../houses/CategoryModal'

function HouseCategory() {
    const [categories, setCategories] = useState([])
    const [loading, setLoading] = useState(false)
    const [action, setAction] = useState(0) 
    const [activeCategory, setActiveCategory] = useState(null)

    const fetchCategories = () => {
        setLoading(true)
        adminServices.adminListCategories()
            .then(res => {
                const data = res.data || []
                setCategories(data)
                setLoading(false)
            })
            .catch(err => {
                console.error('Failed to fetch categories:', err)
                setLoading(false)
            })
    }

    useEffect(() => {
        fetchCategories()
    }, [])

    

    const openModal = (actionType, category = null) => {
        setAction(actionType)
        setActiveCategory(category)
        document.getElementById('category-open-btn')?.click()
    }

    return (
        <div className='space-y-5 w-full'>
            <div className="flex justify-between items-center">
                <h3 className='text-xl text-primary font-bold'>
                    House Categories{' '}
                    <span className='ml-2 text-on-surface-variant/60 text-base font-normal'>
                        ({categories.length})
                    </span>
                </h3>
                <button
                    onClick={() => openModal(0)}
                    className='btn btn-primary rounded-xl btn-sm gap-2'
                >
                    <FaPlus /> Add Category
                </button>
            </div>

            <CategoryModal
                action={action}
                activeCategory={activeCategory}
                onReload={fetchCategories}
                setActiveCategory={setActiveCategory}
            />

            <div className=" rounded-xl border border-outline-variant/15 overflow-hidden">
                <div className='overflow-x-auto'>
                    <table className="table table-zebra w-full">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th className='hidden md:table-cell'>Properties</th>
                                <th className='hidden md:table-cell'>Created</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {categories?.length ? (
                                categories.map((cat) => (
                                    <tr key={cat.id}>
                                        <td className='font-semibold text-primary'>{cat.name}</td>
                                        <td>
                                            <span className="badge badge-ghost badge-sm">
                                                {cat.house_count || 0}
                                            </span>
                                        </td>
                                        <td className='hidden md:table-cell text-xs text-on-surface-variant/60'>
                                            {cat.created_at ? moment(cat.created_at).format('MMM Do, YYYY') : '—'}
                                        </td>
                                        <td>
                                            <div className="flex gap-2">
                                                <button
                                                    onClick={() => openModal(1, cat)}
                                                    className='btn btn-secondary btn-sm rounded-xl text-white'
                                                    title="Edit"
                                                >
                                                    <FaEdit /> Edit
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : null}
                        </tbody>
                    </table>

                    {loading && <Loading />}
                    {!categories?.length && !loading && (
                        <div className="p-6">
                            <Empty objectName="Categories" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default HouseCategory